<template>
  <ValidationProvider
    ref="TOS"
    v-slot="{ errors }"
    :class="$style.termsOfService"
    data-test-id="TermsOfService__Checkbox"
    name="termsOfService"
    :rules="{ required: { allowFalse: false } }"
    tag="div"
  >
    <Checkbox
      v-model="tos"
      :isMarkdown="true"
      :label="handleLabel"
      :name="inputField.termsOfService.name"
      @blur="sendInputEnteredEvent(inputField.termsOfService)"
      @input="$emit('handleClick')"
    />
    <div
      v-if="errors.length > 0"
      :class="$style.inputMessage"
    >
      <span
        data-test-id="InputWrapper__message"
      >
        <Icon
          :class="$style.error"
          icon="error"
        />
        Terms of service is required.
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
import { Checkbox, Icon } from '@jumpcloud/ui-components';
import { ValidationProvider } from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import SignupConstants, { termsOfServiceMessage } from 'client/util/Constants/SignupConstants';

const { optOutCountries } = SignupConstants;

export default {
  name: 'TermsOfServiceCheck',

  components: {
    Checkbox,
    Icon,
    ValidationProvider,
  },

  data() {
    return {
      optOutCountries,
      inputField: {
        termsOfService: {
          name: 'termsOfService',
          label: 'Terms of Service Checkbox', // This is a generic label that is specifically used for the segment event. The actual label that is displayed on the front end is determined by the handleLabel computed property.
        },
      },
    };
  },

  computed: {
    ...mapState(['user']),

    handleLabel() {
      return (this.optOutCountries.indexOf(this.user.country) !== -1)
        ? termsOfServiceMessage.protected
        : termsOfServiceMessage.general;
    },

    tos: {
      get() {
        return this.user.termsOfService;
      },

      set(newVal) {
        this.user.termsOfService = newVal;
      },
    },
  },

  methods: {
    ...mapActions([
      'sendInputEnteredEvent',
    ]),
  },
};
</script>

<style module>
.inputMessage {
  color: var(--jcGrey);
  font-size: var(--jcBodySmall);
  margin-top: var(--jc-size-0p25);
  padding-left: var(--jc-spacer-medium);
}

.error {
  color: var(--jcError);
}

.termsOfService {
  background: var(--jcWhite);
  border-radius: 5px;
  padding: var(--jc-spacer);

  /* legacy fix for variable font size on ios/safari */
  -webkit-text-size-adjust: 100%;
}

.termsOfService div {
  font-size: var(--jcBodySmall);
  line-height: 1.5;
}

.termsOfService a {
  color: var(--jcPrimary);
  text-decoration: none;
}

.termsOfService a:hover {
  color: var(--jcSecondary);
}
</style>
